/** PIN pad helpers — 10-03 staff PIN is 4–6 digits; paste is permitted (07-10 3.3.8). */

export const PIN_MIN_LENGTH = 4;
export const PIN_MAX_LENGTH = 6;

/** 07-02/07-03: idle PIN is a required decision, not a dismissible Team overlay. */
export const PIN_SIGN_IN_MODAL_DISMISSIBLE = false;

/**
 * 10-03 idle handling: re-prompt PIN after 15 minutes of inactivity without
 * discarding the token. 07-02/07-10: idle returns to the staff selector.
 */
export const PIN_IDLE_REPROMPT_MS = 15 * 60 * 1000;

export const PIN_IDLE_RETURN_COPY = 'Select who is using this device.';

export function appendPinDigit(pin: string, digit: string): string {
  if (!/^\d$/.test(digit)) return pin;
  if (pin.length >= PIN_MAX_LENGTH) return pin;
  return `${pin}${digit}`;
}

export function deletePinDigit(pin: string): string {
  return pin.slice(0, -1);
}

export function sanitisePinInput(value: string): string {
  return value.replace(/\D/g, '').slice(0, PIN_MAX_LENGTH);
}

export function pinIsComplete(pin: string): boolean {
  return pin.length >= PIN_MIN_LENGTH && pin.length <= PIN_MAX_LENGTH;
}

/** 10-03: no repeated digits (all the same). */
export function pinHasRepeatedDigits(pin: string): boolean {
  return pin.length >= PIN_MIN_LENGTH && /^(.)\1+$/.test(pin);
}

/** 10-03: no sequential digits (1234 / 4321). */
export function pinIsSequential(pin: string): boolean {
  if (pin.length < PIN_MIN_LENGTH) return false;
  let ascending = true;
  let descending = true;
  for (let i = 1; i < pin.length; i += 1) {
    const delta = Number(pin[i]) - Number(pin[i - 1]);
    if (delta !== 1) ascending = false;
    if (delta !== -1) descending = false;
  }
  return ascending || descending;
}

/** Manager-set PIN: 4–6 digits, not sequential, not all repeated (10-03). */
export function pinMeetsPolicy(pin: string): boolean {
  return pinIsComplete(pin) && !pinHasRepeatedDigits(pin) && !pinIsSequential(pin);
}
